import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const usuarioFindAll = async () => {
  const headers = { "Content-Type": "application/json" };
  return await axios.get(url + "/v1/usuario/findall", { headers });
};

export const usuarioFindByNotSitId = async(sitId) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/usuario/findbynotsitid/' + sitId, {headers});
}

export const usuarioInsert = async (usuario) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.post(url + "/v1/usuario/insert", usuario, { headers });
};

export const usuarioUpdate = async (usuario) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.put(url + "/v1/usuario/update", usuario, { headers });
};

export const usuarioDelete = async (usuario) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.delete(
    url + "/v1/usuario/delete",
    { data: usuario },
    { headers }
  );
};

export const usuarioPermissao = async (usuemail) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.get(url + "/v1/usuario/permissao/" + usuemail, {
    headers,
  });
};

export const usuarioChangePwd = async (usuario) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.put(url + "/v1/usuario/changepwd", usuario, { headers });
};

export const usuarioForgetPassword = async (usuario) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.post(url + "/v1/usuario/forgetpassword", usuario, {
    headers,
  });
};

export const usuarioNextSequence = async (usuid) => {
  const headers = { "Content-Type": "application/json" };
  //  console.log("React", usuid);
  return await axios.get(url + "/v1/usuario/nextsequence/" + usuid, {
    headers,
  });
};
